module.exports = __webpack_public_path__ + "media/2022/briana-berger-21c58813.jpg";